import TrustBar from "../../components/feature/TrustBar";
import SectionPageHero from "../../components/feature/SectionPageHero";
import ProcessSection from "../home/components/ProcessSection";
import WhyChooseUs from "../home/components/WhyChooseUs";
import ServiceAreasSection from "../home/components/ServiceAreasSection";
import TestimonialsSection from "../home/components/TestimonialsSection";
import FinalCTASection from "../home/components/FinalCTASection";
import { Link } from "react-router-dom";
import { serviceAreas } from "../../mocks/services";
import { useState } from "react";

const AREA_SERVICES = [
  { icon: "ri-water-flash-line", title: "Plumbing Repairs in DFW", desc: "Complete residential and commercial plumbing repair and replacement services throughout the Dallas–Fort Worth area." },
  { icon: "ri-fire-line", title: "Heating Services DFW", desc: "Expert heating system repair, installation, and maintenance for all DFW-area residential and commercial properties." },
  { icon: "ri-git-branch-line", title: "Drain Cleaning Across DFW", desc: "Professional drain clearing and sewer line cleaning throughout Cedar Hill, Fort Worth, Dallas, and all DFW communities." },
  { icon: "ri-temp-hot-line", title: "Water Heater Services DFW", desc: "Water heater repairs, replacements, and tankless installations for all DFW homeowners and businesses." },
];

const LOCATION_FAQS = [
  { id: 1, q: "Who is the best plumber in Cedar Hill, TX?", a: "Jerry's Plumbing, Heating & Welding is Cedar Hill's most trusted plumbing provider, known throughout DFW for fast response, quality workmanship, transparent pricing, and reliable long-term solutions backed by 35+ years of local experience." },
  { id: 2, q: "Do you offer emergency plumbing in Fort Worth and Dallas?", a: "Yes — Jerry's provides 24/7 emergency plumbing services across Fort Worth, Dallas, and all DFW service areas. We respond quickly to urgent plumbing situations including burst pipes, gas leaks, flooding, and severe drain backups to prevent further property damage." },
  { id: 3, q: "Why choose a local DFW plumbing company?", a: "Local companies like Jerry's provide faster response times, understand DFW-specific plumbing systems including clay soil pipe shifting and older cast-iron sewer infrastructure, and offer more personalized service than national chains. You speak directly with the team every time." },
  { id: 4, q: "Do you serve all of the DFW metroplex?", a: "Yes — Jerry's serves Cedar Hill, Arlington, Fort Worth, Dallas, Bedford, Burleson, Colleyville, Coppell, Euless, Grand Prairie, Grapevine, Irving, Keller, Mansfield, North Richland Hills, Southlake, and many surrounding communities." },
  { id: 5, q: "What plumbing problems are common in DFW homes?", a: "DFW homes commonly experience slab leaks due to expansive clay soil that shifts foundations, corroded cast-iron sewer lines in older neighborhoods, hard water mineral buildup clogging pipes and water heaters, and extreme Texas heat stressing water heater components." },
  { id: 6, q: "How fast can you reach me in Cedar Hill or Arlington?", a: "As a Cedar Hill-based plumbing company, we can typically reach Cedar Hill and nearby areas like Arlington, Grand Prairie, and Mansfield within 30–60 minutes for standard calls. Emergency calls are prioritized and dispatched immediately — call (817) 832-4968." },
];

export default function LocationPage() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <main className="pt-[100px]">
      {/* 1. Hero */}
      <SectionPageHero
        badge="DFW Service Areas — Cedar Hill, TX Based"
        headline={<>Trusted Plumbing &amp; Heating Services Across <span className="text-[#E8500A]">Dallas–Fort Worth, Texas</span></>}
        subheadline="Based in Cedar Hill, TX — Jerry's Plumbing, Heating & Welding provides fast, reliable plumbing and heating services throughout the entire Dallas–Fort Worth metroplex for over 35 years."
        imageUrl="https://public.readdy.ai/ai/img_res/eed546b546c25d2f2e6e7d2cee76ac12.jpg"
        stats={[{ value: "16+", label: "DFW Cities" }, { value: "35+", label: "Years Serving" }, { value: "24/7", label: "Emergency" }]}
      />

      {/* 2. Trust Bar */}
      <TrustBar />

      {/* 3. Services Available (Adapted Content) */}
      <section className="bg-[#F8F7F4] py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <p className="text-[#E8500A] font-bold text-xs tracking-widest uppercase mb-3">What We Offer</p>
            <h2 className="text-4xl font-black text-gray-900 mb-4" style={{ fontFamily: "'Barlow', sans-serif" }}>Services Available Across DFW</h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
            {AREA_SERVICES.map((svc) => (
              <div key={svc.title} className="group bg-white hover:bg-[#E8500A] rounded-2xl p-6 text-center transition-all duration-300 border border-gray-100 hover:border-[#E8500A]">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-orange-50 group-hover:bg-white/20 mx-auto mb-4 transition-colors">
                  <i className={`${svc.icon} text-[#E8500A] group-hover:text-white text-xl transition-colors`} />
                </div>
                <h3 className="font-black text-gray-900 group-hover:text-white text-sm mb-2 transition-colors" style={{ fontFamily: "'Barlow', sans-serif" }}>{svc.title}</h3>
                <p className="text-gray-500 group-hover:text-white/75 text-xs leading-relaxed transition-colors">{svc.desc}</p>
              </div>
            ))}
          </div>
          {/* Cities + Map */}
          <div className="grid lg:grid-cols-2 gap-8 items-start">
            <div>
              <h3 className="font-black text-2xl text-gray-900 mb-3" style={{ fontFamily: "'Barlow', sans-serif" }}>DFW Communities We Serve</h3>
              <p className="text-gray-500 text-sm mb-6">Our service area covers Cedar Hill and the surrounding DFW metroplex. If your city isn&apos;t listed, call us — we may still serve you.</p>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-6">
                {serviceAreas.map((area) => (
                  <div key={area} className="flex items-center gap-2 bg-white rounded-lg px-4 py-3 text-sm font-semibold text-gray-700 border border-gray-100">
                    <i className="ri-map-pin-fill text-[#E8500A] text-xs flex-shrink-0" />{area}
                  </div>
                ))}
              </div>
              <a href="tel:8178324968" className="inline-flex items-center gap-2 bg-[#E8500A] hover:bg-[#d14508] text-white font-bold px-6 py-3.5 rounded-lg text-sm whitespace-nowrap transition-colors">
                <i className="ri-phone-fill" /> Call to Check Your Area
              </a>
            </div>
            <div className="rounded-2xl overflow-hidden h-[380px] border border-gray-100">
              <iframe
                title="Jerry's Plumbing DFW service area map"
                src="https://maps.google.com/maps?q=Cedar+Hill+TX&t=&z=10&ie=UTF8&iwloc=&output=embed"
                className="w-full h-full border-0"
                loading="lazy"
                aria-label="DFW service area map for Jerry's Plumbing & Heating"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 4. AI Answer Block */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8">
            <div className="bg-[#F8F7F4] rounded-2xl p-8 border-l-4 border-[#E8500A]">
              <h2 className="font-black text-2xl text-gray-900 mb-3" style={{ fontFamily: "'Barlow', sans-serif" }}>Who Provides Plumbing & Heating Across DFW?</h2>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">Jerry's Plumbing, Heating & Welding provides full-service plumbing and heating solutions for homes and businesses across Cedar Hill, Fort Worth, Dallas, Arlington, and the entire DFW metroplex — with fast response, transparent pricing, and reliable results backed by 35+ years of local expertise.</p>
            </div>
            <div className="bg-[#F8F7F4] rounded-2xl p-8 border-l-4 border-gray-200">
              <h2 className="font-black text-2xl text-gray-900 mb-3" style={{ fontFamily: "'Barlow', sans-serif" }}>Local DFW Knowledge Matters</h2>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">DFW homes have unique plumbing challenges — expansive clay soil that shifts foundation pipes, older cast-iron sewer systems in established neighborhoods, and extreme Texas heat that stresses water heaters. Jerry's knows these local conditions and how to address them correctly and permanently.</p>
            </div>
          </div>
        </div>
      </section>

      {/* 5. Process */}
      <ProcessSection />

      {/* 6. Why Choose Us */}
      <WhyChooseUs />

      {/* 7. Service Areas (Shared) */}
      <ServiceAreasSection />

      {/* 8. Testimonials */}
      <TestimonialsSection />

      {/* 9. FAQ */}
      <section className="bg-[#F8F7F4] py-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <p className="text-[#E8500A] font-bold text-xs tracking-widest uppercase mb-3">Location FAQ</p>
            <h2 className="text-4xl font-black text-gray-900" style={{ fontFamily: "'Barlow', sans-serif" }}>DFW Service Area Questions</h2>
          </div>
          <dl className="space-y-3">
            {LOCATION_FAQS.map((faq) => (
              <div key={faq.id} className={`rounded-xl border overflow-hidden transition-all ${openId === faq.id ? "border-[#E8500A]/30 bg-orange-50/60" : "border-gray-200 bg-white hover:border-orange-200"}`}>
                <dt>
                  <button className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer" onClick={() => setOpenId(openId === faq.id ? null : faq.id)}>
                    <span className={`font-bold text-sm pr-4 leading-snug ${openId === faq.id ? "text-[#E8500A]" : "text-gray-900"}`}>{faq.q}</span>
                    <span className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 ${openId === faq.id ? "bg-[#E8500A] text-white" : "bg-gray-100 text-gray-500"}`}>
                      <i className={`text-sm ${openId === faq.id ? "ri-subtract-line" : "ri-add-line"}`} />
                    </span>
                  </button>
                </dt>
                {openId === faq.id && <dd className="px-6 pb-5"><p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p></dd>}
              </div>
            ))}
          </dl>
        </div>
      </section>

      {/* 10. Final CTA */}
      <FinalCTASection />
    </main>
  );
}
